import { Company } from "../../state/entities";
import { logger } from "../../helpers/tslog";

const COMPANIES_KEY = "companies";

export function setCompanies(companies: Company[]): void {
  try {
    localStorage.setItem(COMPANIES_KEY, JSON.stringify(companies));
  } catch (err) {
    logger.error("Failed to save companies:", err);
  }
}

export function getCompanies(): Company[] {
  try {
    const data = localStorage.getItem(COMPANIES_KEY);
    return data ? JSON.parse(data) : [];
  } catch (err) {
    logger.error("Failed to load companies:", err);
    return [];
  }
}

export function findCompanyByName(name: string): Company | undefined {
  return getCompanies().find((c) => c.companyNameAndTicker === name);
}
